// Skills Section Logo's
import htmlLogo from './assets/tech_logo/html.png';
import cssLogo from './assets/tech_logo/css.png';
import javascriptLogo from './assets/tech_logo/javascript.png';
import reactjsLogo from './assets/tech_logo/reactjs.png';
import reduxLogo from './assets/tech_logo/redux.png';
import ViteLogo from './assets/tech_logo/Vite.jpg';
import tailwindcssLogo from './assets/tech_logo/tailwindcss.png';
import nodejsLogo from './assets/tech_logo/nodejs.png';
import expressjsLogo from './assets/tech_logo/express.png';
import mongodbLogo from './assets/tech_logo/mongodb.png';
import javaLogo from './assets/tech_logo/java.png';
import gitLogo from './assets/tech_logo/git.png';
import githubLogo from './assets/tech_logo/github.png';
import vscodeLogo from './assets/tech_logo/vscode.png';
import postmanLogo from './assets/tech_logo/postman.png';
import vercelLogo from './assets/tech_logo/vercel.png';
import SqlLogo from './assets/tech_logo/Sql.png';
import springbootLogo from './assets/tech_logo/springboot.png';
import SringDataLogo from './assets/tech_logo/SringData.png';
import restaiLogo from './assets/tech_logo/restai.png';
import mysqlLogo from './assets/tech_logo/mysql.png';
import postgresLogo from './assets/tech_logo/postgres.png';
import firebaseLogo from './assets/tech_logo/firebase.png';
import socketLogo from './assets/tech_logo/socket.png';
import razorpayLogo from './assets/tech_logo/razorpay.png';
import jwtLogo from './assets/tech_logo/jwt.jpg';
import zxingLogo from './assets/tech_logo/zxing.png';

// Educational Section logo's
import lnctLogo from './assets/educational_logo/Lnct-logo.jpg';
import carmelLogo from './assets/educational_logo/carmel-logo.png';

// Project Section logo's
import courseLogo from './assets/Project_logo/course.png';
import foodLogo from './assets/Project_logo/vingo.png'
import ticketLogo from './assets/Project_logo/ticketimg.jpg'

export const SkillsInfo = [
  {
    title: 'Languages',
    skills: [
      { name: 'Java', logo: javaLogo },
      { name: 'JavaScript(ES6+)', logo: javascriptLogo },
      { name: 'SQL', logo: SqlLogo },
      { name: 'HTML5', logo: htmlLogo },
      { name: 'CSS3', logo: cssLogo },
    ],
  },
  {
    title: 'Frontend',
    skills: [
      { name: 'React JS', logo: reactjsLogo },
      { name: 'Redux', logo: reduxLogo },
      { name: 'VITE', logo: ViteLogo },
      { name: 'Tailwind CSS', logo: tailwindcssLogo },
    ],
  },
  {
    title: 'Backend',
    skills: [
      { name: 'Spring Boot', logo: springbootLogo },
      { name: 'SpringData JPA', logo: SringDataLogo },
      { name: 'Node JS', logo: nodejsLogo },
      { name: 'Express JS', logo: expressjsLogo },
      { name: 'Spring Security', logo: mongodbLogo },
      { name: 'REST API', logo: restaiLogo },
    ],
  },
  {
    title: 'Database',
    skills: [
      { name: 'MySQL', logo: mysqlLogo },
      { name: 'PostgreSQL', logo: postgresLogo },
      { name: 'MongoDB', logo: mongodbLogo },
    ],
  },
  {
    title: 'Tools',
    skills: [
      { name: 'Git', logo: gitLogo },
      { name: 'GitHub', logo: githubLogo },
      { name: 'VS Code', logo: vscodeLogo },
      { name: 'Postman', logo: postmanLogo },
      { name: 'Firebase', logo: firebaseLogo },
      { name: 'Vercel', logo: vercelLogo },
      { name: 'Socket.IO', logo: socketLogo },
      { name: 'Razorpay', logo: razorpayLogo },
      { name: 'JWT', logo: jwtLogo },
      { name: 'ZXing (QR Engine)', logo: zxingLogo },
    ],
  },
];

export const education = [
  {
    id: 0,
    img: lnctLogo,
    school: "LNCT College, Bhopal",
    date: "Oct 2022 - June 2026",
    grade: "71.6%",
    desc: "Graduate B.Tech in Computer Science & Engineering with speacialization in Artificial Intelligence & Data Science and a strong focus on Data Structures, Algorithms, Enterprise Java Architecture, and Database Management Systems.",
    degree: "Bachelor of Technology - Computer Science & Engineering (AIDS)",
  },
  {
    id: 1,
    img: carmelLogo,
    school: "Carmel School, Kareli",
    date: "Till July 2021",
    grade: "72.8%",
    desc: "Completed Class 12 education under the CBSE board, focusing on Physics, Chemistry, and Mathematics (PCM).",
    degree: "CBSE (XII) - PCM",
  },
  {
    id: 2,
    img: carmelLogo,
    school: "Carmel School, Kareli",
    date: "Till May 2019",
    grade: "64%",
    desc: "Completed Class 10 education under the CBSE board.",
    degree: "CBSE (X)",
  },
];

export const projects = [
  {
    id: 0,
    title: "Event Ticket Platform",
    description:
       "Developed a secure, scalable RESTful API backend using Spring Boot and Hibernate/JPA. Implemented robust exception handling, Spring Security with JWT authentication, and optimized database relational mapping for high-performance data processing.",
    image: ticketLogo, // Aap yahan Java project ka image dal sakte ho baad me
    tags: ["Java" , "Spring Boot" , "Spring Security (OAuth2/JWT)" , "REST API" , "React.js (Vite)" , "PostgreSQL" , "ZXing" ,"Tailwind CSS"],
    github: "https://github.com/yashhssoni/ticket-backend",
    webapp: "https://ticket-frontend-ph0q.onrender.com",
  },
  {
    id: 1,
    title: "E-learning Platform",
    description:
       "Engineered a comprehensive MERN ed-tech platform featuring role-based user authentication, interactive course management dashboards, secure media handling, and Razorpay payment integration.",
    image: courseLogo,
    tags: ["React JS", "Node JS", "Express JS", "MongoDB", "Tailwind CSS", "Razorpay" , "AI Bot"],
    github: "https://github.com/yashhssoni/CourseStudy",
    webapp: "https://course-study-smoky.vercel.app/",
  },
  {
    id: 2,
    title: "Food Delivery Platform",
    description:
       "Developed a full-stack MERN food ordering application featuring secure authentication workflows, dynamic restaurant menus, cart state management, and real-time order processing backed by robust RESTful APIs.",
    image: foodLogo,
    tags: ["React JS", "Node JS", "Express JS", "MongoDB", "Tailwind CSS", "Razorpay" , "Socket.io"],
    github: "https://github.com/yashhssoni/vingo",
    webapp: "https://vingo-d7hj.onrender.com",
  },
];